<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>ログイン情報設定</template>
      <template v-slot:annotation>
        システムオーナーのログイン情報を変更する場合は、名称を変更後、変更ボタンをクリックしてください。
      </template>
    </PageHeader>

    <v-form ref="owner_form">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <FormInputComponent
            label="システムオーナーログイン名"
            v-model="ownerLoginId"
            rules="loginIdRules"
            :counter="256"
          />

          <FormInputComponent
            label="現在のパスワード"
            v-model="currentPassword"
            rules="passwordRules"
            :counter="8"
            type="password"
          />

          <FormInputComponent
            label="変更後のパスワード"
            v-model="changePassword"
            rules="passwordRules"
            :counter="8"
            type="password"
          />

          <FormInputComponent
            label="変更後のパスワード（再）"
            v-model="changePasswordRetry"
            rules="passwordRules"
            :counter="8"
            type="password"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-row>
      <v-col cols="6" sm="6" md="4" lg="2">
        <Button @click="erntry_confirm()" color="primary">変更</Button>
      </v-col>
    </v-row>

    <Loader :loading="loading" />

    <div>
      <ConfirmDialog
        ref="confirm"
        title="オーナーログイン情報編集"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="editOwnerLoginInfo"
      >
      </ConfirmDialog>
    </div>
    <div>
      <ConfirmDialog
        ref="confirm_done"
        title="パスワード変更完了"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="passwordChangeDone"
      >
      </ConfirmDialog>

      <DialogMessage ref="dialog" />
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import config from '../../const.js';
import message from '../../message.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, encrypt256 } from '../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'ログイン情報設定',
          route: 'LoginInfo',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      confirmMessage: null,

      // システムオーナーログイン名
      ownerLoginId: null,

      ownerPassword: null,
      // 現在のパスワード
      currentPassword: '',

      // 変更後のパスワード
      changePassword: '',

      // 変更後のパスワード（再）
      changePasswordRetry: '',

      ownerUserId: null,
      updateAt: null,
    };
  },
  created() {
    // オーナー情報取得
    this.get_owner();
  },

  methods: {
    async get_owner() {
      // システムオペレーション情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // ローディング画像表示
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_OWNER_URL +
            '/Owner/owner/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            config.EMPTY_STRING +
            '/' +
            config.EMPTY_STRING
        )
        .then((response) => {
          if (response.data.length == 0) {
            let errStr = 'システムオーナーのユーザ情報が存在しません。';
            this.$refs.dialog.open('info', errStr);
            return;
          } else {
            // システムオーナーユーザ情報取得
            vm.items = response.data;
            this.ownerUserId = vm.items[0].USER_ID;
            this.ownerLoginId = vm.items[0].LOGIN_ID.replaceAll(
              vm.items[0].ORGANIZATION_KEY,
              ''
            );
            this.ownerPassword = vm.items[0].PASSWORD;
          }
        })
        .catch((error) => {
          this.ownerUserId = null;
          this.ownerLoginId = null;
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.owner_form.validate()) {
        return;
      }
      // 現在のパスワードチェック
      if (this.ownerPassword != encrypt256(this.currentPassword)) {
        this.$refs.dialog.open(
          'info',
          '現在のパスワードが違います。\n ご確認の上、再度、現在のパスワードをご入力下さい。'
        );
        return;
      }
      // 変更後パスワードチェック
      if (this.changePassword != this.changePasswordRetry) {
        this.$refs.dialog.open(
          'info',
          '変更後のパスワードと変更後のパスワード(再)の入力値が違います。\n 再度、変更後のパスワードをご入力下さい。'
        );
        return;
      }

      // パスワード整合性チェック
      if (this.ownerPassword == encrypt256(this.changePassword)) {
        this.$refs.dialog.open(
          'info',
          '入力された変更後のパスワードは現在のパスワードと同じです。\n 再度、現在のパスワードとは違うパスワードをご入力下さい。'
        );
        return;
      }

      // 確認ダイアログ表示
      this.confirmMessage = 'システムオーナーのログイン情報を変更しますか？';
      this.$refs.confirm.open();
    },
    editOwnerLoginInfo() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      //----- システムオーナーログイン情報更新リクエストPUT
      axios
        .put(
          config.CONNECT_OWNER_URL +
            '/Owner/owner/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            userInfo.ORGANIZATION_KEY +
            '/' +
            this.ownerLoginId +
            '/' +
            encrypt256(this.changePassword)
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          // パスワード設定
          let originalPassword = this.ownerPassword.substr(0, 10);
          if (originalPassword != this.changePassword) {
            this.ownerPassword = encrypt256(this.changePassword);
          }

          // 完了メッセージ表示
          if (response.status == 200) {
            this.confirmMessage = message.MSG_INFO_PASSWORD_ENTRY_COMPLETE;
            this.$refs.confirm_done.open();
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else if (error.response.status == 422) {
            errStr = message.MSG_INFO_OWNER_LOGINID_ALREADY_EXISTS;
            // システムオーナーのログイン名が既に存在している
            this.$refs.dialog.open('info', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    passwordChangeDone() {
      // ログイン画面に戻る
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
